// extracted by mini-css-extract-plugin
export default {"main":"Root_main__ZWyZX"};